import React from "react";
import { BottomNavigation } from "../header";
import { useNavigate } from "react-router-dom";
import {Avatar} from 'primereact/avatar';
import Logo from "../../../../assets/logo.png";
import { EffectueTable } from "./effectue";
import { useAuthChauffeur } from "../auth";

export const EspaceEffectue = () => {
    const { logout } = useAuthChauffeur();
    const navigate = useNavigate();


const handleLogout = () => {
        logout(); 
        navigate("/chauffeur/login");
    };

  return (
    <div>
      <main
        style={{
          margin: "0 auto",
        }}
      >
        <EffectueTable  />
      </main>

      <BottomNavigation />
    </div>
  );
};